import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#007E31"
}
function ShiMot001({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M22.8 0L0 32.4h45.6L22.8 0z"
                    id="ShiMot001__Symbol_1_0_Layer0_0_FILL"
                />
            </defs>
            <g id="ShiMot001__col1n" transform="translate(169.85 261.7)">
                <use
                    xlinkHref="#ShiMot001__Symbol_1_0_Layer0_0_FILL"
                    id="ShiMot001__col1n_FL"
                />
            </g>
        </g></g>
    )
}
export default ShiMot001
